import { render, staticRenderFns } from "./ClassTrialSkillsTableForm.vue?vue&type=template&id=e368f21a"
import script from "./ClassTrialSkillsTableForm.vue?vue&type=script&lang=js"
export * from "./ClassTrialSkillsTableForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports